import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './migrations';
import App from './App';

function createRoot() {
    const root = document.createElement('div');
    root.id = 'root';
    document.body.appendChild(root);
    return root;
}

document.documentElement.setAttribute(
    'data-theme',
    localStorage.getItem('theme') ?? (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'white'),
);
document.documentElement.setAttribute('data-font', localStorage.getItem('font') ?? 'default');

const rootElement = document.getElementById('root') ?? createRoot();
const root = ReactDOM.createRoot(rootElement);

kofiWidgetOverlay.draw('gddemonladder', {
    type: 'floating-chat',
    'floating-chat.donateButton.text': 'Donate',
    'floating-chat.donateButton.background-color': '#00b9fe',
    'floating-chat.donateButton.text-color': '#fff',
});

root.render(
    <React.StrictMode>
        <App />
        <ToastContainer
            theme='dark'
            pauseOnFocusLoss={false}
            position={window.innerWidth > 640 ? 'bottom-right' : 'top-center'}
        />
    </React.StrictMode>,
);
